exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".form-button[data-v-0f04303d] {\n  margin-top: 5px;\n}\n.content-top[data-v-0f04303d] {\n  margin-top: 10px;\n}\n", ""]);

// exports
